module.exports = __webpack_public_path__ + "img/P150T_weapon_23.38c6131e.png";